import { schema } from 'normalizr';

export const autoallocation = new schema.Entity('autoallocations');
export const autoallocations = [autoallocation];
